module.exports = __webpack_public_path__ + "0118196fb44026f3725b51c8ce05f5ba.png";